import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class ExternalRoleViewModel {
  role;
  userViewModel;

  constructor(role, userViewModel) {
    makeAutoObservable(this);

    this.role = role;
    this.userViewModel = userViewModel;
  }

  toggle() {
    this.checked = !this.checked;
  }

  get checked() {
    return _.includes(this.userViewModel.user.assignedRoles, this.role.id);
  }

  set checked(value) {
    const id = this.role.id;
    const assignedRoles = this.userViewModel.user.assignedRoles;
    const includes = _.includes(assignedRoles, id);

    if (value && !includes) {
      assignedRoles.push(id);
    } else if (!value && includes) {
      assignedRoles.remove(id);
    }
  }
}

export default ExternalRoleViewModel;
